import { Box, Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncGetAccountUser } from "redux/embrillProfileSlice";
import { fetchAsyncBankBalance } from "redux/paymentSlice";

const  CehekBankBalance=({isOpen,onClose,accData,userIds})=> {
    const dispatch = useDispatch();
    const [amount,setAmount] = useState(0)
    const [isLoading,setIsLoading] = useState(false)
    const { addToast } = useToasts();
    const currUser = useSelector((state) => state.auth.currUser);
    const [accountUser, setAccountUser] = useState(false);

    useEffect(() => {
      const getAccountUser = async () => {
        if (currUser && currUser._id) {
          const res = await dispatch(fetchAsyncGetAccountUser(currUser._id));
          if (res?.payload?.isA) {
            setAccountUser(res?.payload);
          } else {
            setAccountUser({});
          }
        } else {
          setAccountUser({});
        }
      };
  
      getAccountUser();
    }, [currUser?._id, dispatch]);

    const fetchBalance = () => {
      if(accountUser?.useId){
        setIsLoading(true)
        const data = {
          corpId:accData?.corId,
          aggrId:accData?.aggId,
          userId:accountUser?.useId,
          urn:accData?.urn,
          debitAcc:accData?.bnk?.acNo
        }
        const userID = userIds?.find((opt)=>opt?.useId === accountUser?.useId);
        if(userID && userID?.sts === 'Registered'){
          dispatch(fetchAsyncBankBalance(data))
            .then((res) => {
              if (res?.payload && res.payload?.data) {
                setAmount(res?.payload?.data?.EFFECTIVEBAL || 0)
                addToast('success', { appearance: "success" });
              } else {
                addToast(`${res?.error?.message}`, { appearance: "error" });
                onClose()
              }
            })
            .catch((error) => {
              addToast('faield', { appearance: "error" });
              onClose()
            }).finally(()=>{
              setIsLoading(false)
            });
        }
        else{
          setIsLoading(false)
          addToast('userId is not registered!', { appearance: "error" });

        }
        
      }
     
    };
    useEffect(()=>{
      fetchBalance()
    },[accData,accountUser])

    const lastFourDigits = accData?.bnk?.acNo ? accData.bnk.acNo.slice(-4) : '';

    return (
      <>
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          isCentered
          className="account-user-modal"
        >
          <ModalOverlay />
          <ModalContent maxH="fit-content" className="add-account-user-modal">
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header">
                    {accData?.bnk?.name} - {lastFourDigits}
              </ModalHeader>
              <ModalCloseButton />
            </div>
            <ModalBody className="mt-5" height={300}>
              {isLoading ? 
                <div className="balance-loader">
                  <Spinner />
                </div>
                :
                <Box className="bank-balance">Available Balance : <span className="f-600">₹ {formatAmountIndianRupees(amount)}</span></Box>

              }
            </ModalBody>

            <ModalFooter>
              
              <Button onClick={onClose} className="btn">
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }

  export default CehekBankBalance;